export default {
  release: '16.8',
  date: 'January 2024',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-8-released/#this-months-notable-contributor',
  contributors: [
    {
      name: 'Ted Tran',
      gitlabUsername: 'tedtran2019',
    },
    {
      name: 'Martin Schurz',
      gitlabUsername: 'schurzi',
    },
    {
      name: 'Helio Cola',
      gitlabUsername: 'heliocola',
    },
  ],
  writeUp: `Ted has made significant contributions [removing old and unused code](https://gitlab.com/gitlab-org/gitlab/-/issues/420057)
from our helper files and addressing other maintenance tasks.
He was nominated by [Kerri Miller](https://gitlab.com/kerrizor), Staff Engineer at GitLab, who said,
"It's not always glamorous work, but it's important work".

Ted is a freelance software engineer, avid climber, and cat enthusiast based in Orange County.

Martin was nominated by [Viktor Nagy](https://gitlab.com/nagyv-gitlab), Product Manager at GitLab, who said,
"He added many missing tests to the Auto Deploy jobs template and improved the [agentk Helm chart documentation](https://docs.gitlab.com/ee/user/clusters/agent/install/#customize-the-helm-installation)".

[Lee Tickett](https://gitlab.com/leetickett-gitlab), Engineer at GitLab, added that he
"has been joining community pairing sessions on [Discord](https://discord.gg/gitlab) and collaborating
closely with team members to contribute a heavily requested [search enhancement](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/140002) for merge requests".

Martin is an IT Architect at Deutsche Telekom MMS GmbH based in Dresden, Germany.

Helio was nominated by [Hannah Sutor](https://gitlab.com/hsutor), Principal Product Manager at GitLab, who said,
"he has pushed our entire team forward by proposing the [ability to sign in using passkeys](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/135324).
Helio's MR was closed, but his contribution was deep, thought provoking, and his questions and open discussion will make our Passwordless implementation better".

Helio is a software engineer with passion for Ruby and OSS.

Thank you Ted, Martin, and Helio! 🙌`,
};
